module.exports = __webpack_public_path__ + "static/media/logoImg.b212ae1e.png";